import { Injectable } from '@angular/core';

import { ApiService } from './api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ModelService {
  constructor(private readonly apiService: ApiService) {}

  getModelsOfGivenWorkspace(workspaceId: string) {
    return this.apiService.httpGet(`/api/campaigns/asset-list/model/${workspaceId}`);
  }

  createNewModel(campaignId: string, data: any) {
    return this.apiService.httpPost(`/api/campaigns/asset-list/model/import-from-campaign/${campaignId}`, data);
  }

  deleteModel(modelId: string) {
    return this.apiService.httpDelete(`/api/campaigns/asset-list/model/${modelId}`);
  }

  saveAssetModel(modelId: string, data: any) {
    return this.apiService.httpPost(`/api/campaigns/asset-list/model/${modelId}`, data);
  }

  deleteAssetModel(modelId: string, assetId: string) {
    return this.apiService.httpDelete(`/api/campaigns/asset-list/model/${modelId}/${assetId}`);
  }

  deleteSubAssetModel(modelId: string, assetId: string, subAssetId: string) {
    return this.apiService.httpDelete(`/api/campaigns/asset-list/model/${modelId}/${assetId}/${subAssetId}`);
  }

  bulkUpdateModelAssets(modelId: string, data: any): Observable<any> {
    return this.apiService.httpPost(`/api/campaigns/asset-list/model/${modelId}/bulk-action`, data);
  }

  exportModelToCampaign(campaignId: string, modelId: string) {
    return this.apiService.httpPost(`/api/campaigns/asset-list/model/export-to-campaign/${modelId}/${campaignId}`, {});
  }
}
